import nls from '../es/PayrollReviewDi';
export default {
  ...nls,
  'Loan details': ' Elija el monto que desea disponer',
  'Credit information': 'Verifique las condiciones del crédito',
  'Check requirements, terms, contract conditions and commissions in': 'Consulte requisitos, términos, condiciones de contratación y comisiones en',
};
